import React from 'react'

import { Box, Typography } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import PublicIcon from '@mui/icons-material/Public'

import IconLockRed from 'assets/icons/lock-red.svg'
import IconTeam from 'assets/icons/icon-team.svg'
import IconCommunity from 'assets/icons/icon-community.svg'

const useStyles = makeStyles({
    label: {
        fontSize: '13px',
        marginLeft: '4px',
        color: 'inherit',
        flexWrap: 'nowrap',
    },
})

const getIconColor = visibility => {
    switch (visibility) {
        default:
        case 'Private':
            return '#cd0000'
        case 'Team':
            return '#00a2eb'
        case 'Connected':
            return '#09b15b'
        case 'Public':
            return '#b953d4'
    }
}

const getPlaybookTypeIcon = visibility => {
    switch (visibility) {
        case 'Public':
            return (
                <PublicIcon
                    style={{ color: getIconColor(visibility) }}
                    fontSize="small"
                />
            )
        case 'Team':
            return <img src={IconTeam} alt="team" />
        case 'Connected':
            return <img src={IconCommunity} alt="connected" />
        case 'Private':
            return <img src={IconLockRed} alt="private" />
        default:
            return
    }
}

type VisibilityType = 'Private' | 'Team' | 'Connected' | 'Public'

type Props = {
    visibility: VisibilityType
}

export const PlaybookVisibility = ({ visibility = 'Private' }: Props) => {
    const classes = useStyles()

    return (
        <Box display="flex" alignItems="center">
            <Box
                style={{ color: getIconColor(visibility) }}
                display="flex"
                alignItems="center"
            >
                {getPlaybookTypeIcon(visibility)}
                <Typography className={classes.label}>{visibility}</Typography>
            </Box>
        </Box>
    )
}
